<form [formGroup]="parentForm" style="margin-bottom: 20px">
  <qbe-panel-component>
    <div nxRow class="outer-element">
      <div nxCol="12, 12, 5" class="outer-element-left">
        <img aemNormalizeUrl src="/assets/img/house.svg" alt="house" />
      </div>
      <div nxCol="12, 12, 7" style="padding: 0px">
        <div class="outer-element-right">
          <div class="outer-element-right-title">
            {{ "home.insuredQuestion" | translate }}
          </div>
          <div class="properties">
            <div class="custom-radio-group" style="display: none">
              <input
                type="radio"
                value="1"
                formControlName="propertyCategory"
              />
            </div>
            <ng-container
              *ngIf="sharedService.$propertyCategories | async as categories"
            >
              <ng-container
                *ngFor="let category of categories?.propertyCategories"
              >
                <div class="custom-radio-group" *ngIf="category">
                  <input
                    type="radio"
                    [value]="category.value"
                    formControlName="propertyCategory"
                  />
                  <qbe-button
                    class="popular-brand-input"
                    mode="secondary"
                  >
                    <label style="position: relative">
                      <nx-icon
                        [name]="icons[category.value]"
                        outline="true"
                        size="s"
                        class="input-icon"
                      ></nx-icon>
                      <input
                        type="radio"
                        [value]="category.value"
                        formControlName="propertyCategory"
                        (click)="propTypeClick(category.value)"
                        (click)="
                        mapTrackService.mapTrackPropertyCategories(category.value)
                      "
                      />
                      <span class="property-select-label">{{
                        category.label
                      }}</span>
                    </label>
                  </qbe-button>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </qbe-panel-component>
</form>

<!-- <div style="margin: 2%;" [innerHTML]="'header.conditions' | translate | safeHtml">
</div> -->
<div class="link-wrapper">
  <div>
    <p class="popUp-link">
      {{ "gdpr.title-link" | translate }}
      <nx-link nxStyle="text">
        <a (click)="openPopUp()">
          <nx-icon name="chevron-right-small"></nx-icon>
        </a>
      </nx-link>
    </p>
  </div>
</div>
<ng-template #template style="height: 651px">
  <div nxModalContent class="gdpr-popUp-wrapper gdpr-max-height-modal">
    <div>
      <center>
        <img
          aemNormalizeUrl
          src="/assets/img/client_and_agent_shaking_hands.svg"
          class="img-content"
        />
      </center>
      <!-- <figure class="img-container" > -->

      <!-- </figure> -->
    </div>
    <h3 class="gdpr-popUp-headline">{{ "gdpr.in-title" | translate }}</h3>
    <h3 class="gdpr-popUp-header">
      {{ "gdpr.privacy-notice-title" | translate }}
    </h3>
    <p class="gdpr-popUp-text">
      {{ "gdpr.privacy-notice-1" | translate }}
      <nx-link nxStyle="text" [innerHtml]="'gdpr.here' | translate"> </nx-link>
      {{ "gdpr.privacy-notice-2" | translate }}
    </p>
    <h3 class="gdpr-popUp-header">{{ "gdpr.pc-title" | translate }}</h3>
    <p class="gdpr-popUp-text">{{ "gdpr.pc" | translate }}</p>
    <p class="gdpr-popUp-text">
      <nx-link
        nxStyle="text"
        [innerHtml]="'gdpr.pc-info-ins' | translate"
      ></nx-link>
    </p>
    <p class="gdpr-popUp-text">
      <nx-link
        nxStyle="text"
        [innerHtml]="'gdpr.pc-info-prod-link' | translate"
      ></nx-link>
    </p>
    <p class="gdpr-popUp-text">
      <nx-link nxStyle="text" [innerHtml]="'gdpr.terms-dist' | translate">
      </nx-link>
    </p>
    <p class="gdpr-popUp-text">{{ "gdpr.pc-2" | translate }}</p>
    <p class="gdpr-popUp-text">
      <nx-link nxStyle="text" [innerHtml]="'gdpr.benefits' | translate">
      </nx-link>
    </p>
    <h3 class="gdpr-popUp-header">{{ "gdpr.signatures-title" | translate }}</h3>
    <p class="gdpr-popUp-text">{{ "gdpr.signatures" | translate }}</p>
    <!-- <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-3m">Modal from a template</h3>
    <p nxCopytext="small" class="nx-margin-bottom-2m">This content is placed within the <code>nx-modal-container</code></p> -->
  </div>
</ng-template>
